// generated by genversion
export var version = '4.7.4';
//# sourceMappingURL=version.js.map